import React from "react";
import CustomChip from "../../../../common/customChip/CustomChip";

const statusChip = {
  PAID: { text: "Paid", textColor: "##0B442D", bgColor: "#BBE2CE" },
  UNPAID: { text: "Not Paid", textColor: "#B32306", bgColor: "#F9D9D7" },
  PARTIALLY_PAID: {
    text: "Partially Paid",
    textColor: "#705010",
    bgColor: "#FFEDC8",
  },
};

const PaymentStatusChip = ({status}) => {
  const statusChipColor = statusChip[status];
  return (
    <div className="ml-2">
    <CustomChip
      bgColor={statusChipColor?.["bgColor"]}
      textColor={statusChipColor?.["textColor"]}
      text={statusChipColor?.["text"]}
      style ={{width:"115px"}}
    >
      {status}
    </CustomChip>
    </div>
  );
};

export default PaymentStatusChip;
